import ReportDeliveryOrderItem from "../../../../components/@reports/sales/ReportDeliveryOrderItem";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/sales/deliveryOrderItemSchema"

export default function DeliveryOrderItemReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.sales}
            reportType={reportTypes.sales.deliveryOrderItem.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportDeliveryOrderItem
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       